
<script setup>

import {computed, defineEmits }   from 'vue';

const emits = defineEmits(['select-document-numbers']);

const props = defineProps({
  documentInfoList: Object,
});


const selectDocumentNumber = (index) => {
  emits('select-document-number', index);
}

const launchAnnualReport = (documentNumber) => {
  window.open(route('annual.report', { documentNumber: documentNumber }), '_blank');
}

const launchEINService = (documentNumber) => {
  window.open(route('document', { documentNumber: documentNumber, productCode: "ein_registration" }), '_blank');
}

const launchBOIRService = (documentNumber) => {
  window.open(route('document', { documentNumber: documentNumber, productCode: "boir" }), '_blank');
}


</script>
<template>
  <div class="bg-slate-100 p-4">
  <div class="max-w-4xl mx-auto min-h-[calc(100vh-400px)]">
    <div class="mt-4 flow-root bg-gray-50 rounded-lg border border-gray-200 shadow-sm p-4">
      <div>
        <div class="w-full py-2 align-middle">
          <div class="block md:hidden">
            <!-- Mobile view - cards instead of table -->
            <div v-for="(document, key) in documentInfoList" :key="key" class="mt-4 mb-4 bg-white p-4 rounded-md border border-gray-200">
              <div class="flex justify-between items-center mb-2">
                <span class="font-medium text-gray-900 ">#{{ key +1 }} {{document.company.name }}</span>
              </div>
              <div class="grid grid-cols-1 gap-2">
                <div>
                  <div class="text-xs text-gray-500">Document</div>
                  <div class="text-sm text-gray-800">{{ document.document_number }}</div>
                </div>
                <div>
                  <div class="text-xs text-gray-500">Company</div>
                  <div class="text-sm text-gray-800 font-bold">{{ document.company.name }}</div>
                </div>
                <div>
                  <div class="text-xs text-gray-500">Owner</div>
                  <div class="text-sm text-gray-800">{{ document.owner?.first_name }} {{ document.owner?.last_name }}</div>
                </div>
                <div>
                  <button @click="launchAnnualReport(document.document_number)" type="button" class="w-full rounded-md bg-blue-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">File Annual Report</button>
                  <button @click="launchEINService(document.document_number)" type="button" class="mt-2 w-full rounded-md bg-emerald-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600">EIN Application Services</button>
                  <button @click="launchBOIRService(document.document_number)" type="button" class="mt-2 w-full rounded-md bg-yellow-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600">BOIR Reporting Services</button>
                  <button @click="selectDocumentNumber(key)" type="button" class="mt-2 w-full rounded-md bg-amber-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-amber-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600">Other Services</button>

                </div>
              </div>
            </div>
          </div>
          
          <!-- Desktop view - grid layout -->
          <div class="hidden md:block bg-white rounded-md">
            <!-- Header -->
            <div class="grid grid-cols-12 gap-2 border-b border-gray-300 bg-gray-50 rounded-t-md">
              <div class="col-span-1 py-3.5 px-4 text-left text-sm font-semibold text-gray-900">#</div>
              <div class="col-span-2 py-3.5 px-4 text-left text-sm font-semibold text-gray-900">Document</div>
              <div class="col-span-3 py-3.5 px-4 text-left text-sm font-semibold text-gray-900">Company</div>
              <div class="col-span-2 py-3.5 px-4 text-left text-sm font-semibold text-gray-900">Owner</div>
              <div class="col-span-4 py-3.5 px-4 text-left text-sm font-semibold text-gray-900">Actions</div>
            </div>
            
            <!-- Rows -->
            <div v-for="(document, key) in documentInfoList" :key="key" class="grid grid-cols-12 gap-2 py-4 border-b border-gray-200 hover:bg-gray-50">
              <div class="col-span-1 px-4 text-sm text-gray-900 flex items-center">{{ key + 1 }}</div>
              <div class="col-span-2 px-4 text-sm text-gray-500 flex items-center">{{ document.document_number }}</div>
              <div class="col-span-3 px-4 text-sm text-gray-500 font-bold flex items-center">{{ document.company.name }}</div>
              <div class="col-span-2 px-4 text-sm text-gray-500 flex items-center">{{ document.owner?.first_name }} {{ document.owner?.last_name }}</div>
              <div class="col-span-4 px-4">
                <button @click="launchAnnualReport(document.document_number)" type="button" class="w-full rounded-md bg-blue-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600">File Annual Report</button>
                <button @click="launchEINService(document.document_number)" type="button" class="mt-2 w-full rounded-md bg-emerald-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600">EIN Application Services</button>
                <button @click="launchBOIRService(document.document_number)" type="button" class="mt-2 w-full rounded-md bg-yellow-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-yellow-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600">BOIR Reporting Services</button>
                <button @click="selectDocumentNumber(key)" type="button" class="mt-2 w-full rounded-md bg-amber-500 px-2.5 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-amber-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-600">Other Services</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
